import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

export interface FooterMenuItem {
  name: string;
  url?: string;
  description?: string;
  icon?: string;
  children?: FooterMenuItem[];
}

export interface FooterData {
  footerMenu: FooterMenuItem[];
  disclaimer: string;
}

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  constructor(private http: HttpClient) {}

  private getApiBaseUrl(): string {
    const lang = localStorage.getItem('language')?.toLowerCase() || 'en';
    return `${environment.apiSearchBaseURL}${lang}`;
  }

  public getFooterData(): Observable<FooterData> {
    return this.http.get<FooterData>(`${this.getApiBaseUrl()}/footer-data`);
  }
}
